/* unplugin-vue-components disabled */import script from "./error-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./error-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./error-dialog.vue?vue&type=style&index=0&id=1855d937&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1855d937"]])

export default __exports__